module.exports = __webpack_public_path__ + "static/media/Orto botanico - DK Grey_LT Gold.e3789a53.jpg";